import { useEffect, useState } from 'react'
import TerminalList from './TerminalList'
import { useRequest } from '../../api/utils'
import { useSearchTerminals } from '../../api/terminalApi'
import { Page } from '../../api/pagination/page'
import { Banner, LoadingWand } from '@ordr-as/umami-react'
import { useSearchParams } from 'react-router-dom'
import PaginationButtons from '../../components/PaginationButtons'
import Search from '../../components/Search'
import { TerminalDto } from '../../../generated-api'

const toIntOrZero = (maybeInt: string | null) => {
    if (maybeInt === null) return 0
    const parsed = parseInt(maybeInt)
    return isNaN(parsed) ? 0 : parsed
}

const TerminalsOverview = () => {
    const [searchParams, setSearchParams] = useSearchParams()
    const searchParam = 'pspTerminalId'
    const [terminals, setTerminals] = useState<Page<TerminalDto>>()
    const searchTerminals = useSearchTerminals()

    const searchQuery = searchParams.get('q') || ''
    const pageNumber = toIntOrZero(searchParams.get('page'))

    const {
        run: runGetTerminals,
        loading,
        error,
    } = useRequest(() => searchTerminals(searchParam, searchQuery, pageNumber))

    const [searchQueryEffectCompletedInitialRun, setSearchQueryEffectCompletedInitialRun] = useState<boolean>(false)

    useEffect(() => {
        runGetTerminals().then((terminalsPage) => {
            setTerminals(terminalsPage)
        })

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pageNumber])

    useEffect(() => {
        if (searchQueryEffectCompletedInitialRun && pageNumber > 0) {
            setPageNumber(0)
            return
        }

        runGetTerminals().then((terminalsPage) => {
            setTerminals(terminalsPage)
        })

        setSearchQueryEffectCompletedInitialRun(true)

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [searchQuery])

    const cancelSearchFilter = () => {
        setPageNumber(0)
        setSearchParams({})
    }

    const setPageNumber = (pageNumber: number) => {
        setSearchParams(searchQuery ? { q: searchQuery, page: pageNumber.toString() } : { page: pageNumber.toString() })
    }

    const setSearchQuery = (newQuery: string) => setSearchParams({ q: newQuery, page: pageNumber.toString() })

    return (
        <div className="m-6">
            <h1>Terminals</h1>
            {loading ? (
                <LoadingWand className="mx-auto" />
            ) : error ? (
                <Banner kind="error" onClose={() => null} stretch="parent" className="my-3">
                    {error?.message}
                </Banner>
            ) : (
                <div className="py-2 max-w-full">
                    <Search
                        placeHolder="Search by psp terminal id"
                        initialValue={searchQuery}
                        onSubmit={setSearchQuery}
                        onCancel={cancelSearchFilter}
                    />

                    <TerminalList terminals={terminals?.pageContent || []} />
                    <PaginationButtons page={terminals} onSwapPage={setPageNumber} />
                </div>
            )}
        </div>
    )
}

export default TerminalsOverview
